export const TOSlistData = [
  {
    id:1,
    startupName: "VirtualGGC",
    website: "https://virtualggc.com/",
    // startupLogo:"https://drive.google.com/uc?export=view&id=1k6PJItGxjZFPgw9II_AKQshBlFS8IdhA",
    // startupLogo:"https://drive.google.com/file/d/1C-_Nd8H9pfKBNxiEwQmq-SfbT8jjMvjj/view?usp=drivesdk",
    startupLogo: "https://drive.google.com/uc?export=view&id=1C-_Nd8H9pfKBNxiEwQmq-SfbT8jjMvjj",
    pSummary: "At VirtualGGC, they are committed to transforming the way you approach finances by providing a unique blend of comprehensive financial services and top-notch educational resources. Their goal is to empower individuals like you to take control of your financial well-being and achieve your dreams in the virtual world. Financial Services: Their team of experienced financial experts is dedicated to guiding you through the complexities of the financial landscape. Whether you're looking for personalized investment strategies, retirement planning, debt management, or assistance with budgeting and saving, VirtualGGC has you covered. They believe that everyone deserves access to reliable financial services that align with their goals, and we strive to make the process efficient, transparent, and tailored to your needs. Financial Education: At VirtualGGC, they understand that financial literacy is crucial for long-term success. That's why they go beyond traditional financial services and provide wealth.",

    legal_name: "GGC'S PRACTICAL TRAINING ACADEMY PRIVATE LIMITED",
    industry: "Fintech",
    basedOutOf: "Maharashtra, India",
    business_model: "B2B, B2C",
    founding_date: "2023",
    employee_headcount: "41 to 60",
    team_member: [
      {
        name: "Ritika Agarwal",
        designation: "Co-Founder",
        profile_link: "https://www.linkedin.com/in/ritika-tajpuriya-429b8a52/",
      },
      {
        name: "Sumit Tajpuriya",
        designation: "Co-Founder",
        profile_link:
          "https://www.linkedin.com/in/sumit-tajpuriya-9b51323a/",
      },
    ],
    revenue_stream:
      "E-commerce product ",
    customerGroup: "Collaboration, Consumer, Services",
    clientBusinessStructure: "Startup",
    geogriphicalSegment: "India,  India Tier 1,  India Tier 2,  India Tier 3, Global",
    ageGroup: "26 to 34,  35 to 45,  46 to 60 ",
    incomeBracket: "Lower-middle Income,  Upper-middle Income,  High Income",
    userBelongsTo: "India,  India Tier 1,  India Tier 2,  India Tier 3,  Global",
  },

  {
    id:2,
    startupName: "BitSave",
    website: "https://www.bitsave.club/",
    startupLogo: "https://drive.google.com/uc?export=view&id=1C3Y7OpX9wQN0KLCNImEj6MZa16NTTUu2",
    pSummary: "BitSave is a comprehensive crypto investment platform designed to solve the problem of asset selection and capital loss for long-term investors. BitSave functions by offering a range of index funds based on reputable and trusted cryptocurrency indices, such as Bloomberg's Crypto Index BGCI.",
    legal_name: "Casper Wealth Pte. Ltd",
    industry: "Fintech",
    basedOutOf: "Singapore, Global ",
    business_model: "B2B, B2C",
    founding_date: "2022",
    employee_headcount: "<10",
    team_member: [
      {
        name: "Zakhil Suresh",
        designation: "Co-Founder",
        profile_link: "https://www.linkedin.com/in/zakhilsuresh/",
      },
      {
        name: "Asif Kattakath",
        designation: "Co-Founder",
        profile_link:"https://www.linkedin.com/in/asifkattakath/",
      },
      {
        name: "Vishnu Karthik",
        designation: "Co-Founder",
        profile_link:"https://www.linkedin.com/in/vishnukarthikeyan/",
      },
    ],
    revenue_stream:"Fee-for-service",
    customerGroup: "",
    clientBusinessStructure: "",
    geogriphicalSegment: "",
    ageGroup: "26 to 34, 35 to 45",
    incomeBracket: "Lower-middle Income,  Upper-middle Income,  High Income  ",
    userBelongsTo: "Global",
    totalfunding:"0.08M",
  },

  {
    id:3,
    startupName: "Sharpely",
    website: "https://sharpely.in/",
    // https://drive.google.com/file/d/1C1zXysfyxgA5eS8V6BxS866d8V6ZN-q-/view?usp=drivesdk
    startupLogo: "https://drive.google.com/uc?export=view&id=1C1zXysfyxgA5eS8V6BxS866d8V6ZN-q-",
    pSummary: "Thane-based startup Company was founded by Shubham Satyarth in 2023. sharpely is a data-driven investment research platform. SEBI registered Research Analyst. SEBI Registration no. INH000009524",

    legal_name: "Mintbox Solutions Private Limited",
    industry: "Fintech",
    basedOutOf: "Maharashtra, India",
    business_model: "B2C",
    founding_date: "2023",
    employee_headcount: "11 to 20",
    team_member: [
      {
        name: "Shubham Satyarth",
        designation: "Co-Founder",
        profile_link: "https://www.linkedin.com/in/shubham-satyarth-03910021/",
      },
      
    ],
    revenue_stream:
      "Freemium, subscription ",
    customerGroup: "",
    clientBusinessStructure: "",
    geogriphicalSegment: "",
    ageGroup: "18 to 25,  26 to 34,  35 to 45",
    incomeBracket: "Lower-middle Income,  Upper-middle Income,  High Income",
    userBelongsTo: "India,  India Tier 1,  India Tier 2,  India Tier 3,  Global",
    totalfunding:"",
  },

  {
    id:4,
    startupName: "AGAM AI",
    website: "https://agam.ai/",
    startupLogo: "https://drive.google.com/uc?export=view&id=1CeB61bYR0DP0shVqe96YaaIQERhnjvht",
    pSummary: "AGAM is an AI driven digital SaaS platform connecting individual and businesses to banks, NBFIs and MFIs to enable instant access to finance. Available in API, APK and SDK for banks and digital financial platforms alike to connect and setup lending engine. AGAM enables banks and financial institutions to facilitate end to end digital lending with credit scoring and borrowing mechanism.",
    legal_name: "AGAM AI",
    industry: "Fintech",
    basedOutOf: "United Kingdom, Global",
    business_model: "B2B",
    founding_date: "2019",
    employee_headcount: "21 to 40",
    team_member: [
      {
        name: "Shabnam Wazed",
        designation: "Founder and CEO",
        profile_link: "https://www.linkedin.com/in/shabnam-wazed-4830b9142/",
      },
      {
        name: "Rohit Sankhe",
        designation: "Chief Technology Officer",
        profile_link:
          "https://www.linkedin.com/in/rohitsankhe/",
      },
    ],
    revenue_stream:
      "",
    customerGroup: "",
    clientBusinessStructure: "",
    geogriphicalSegment: "",
    ageGroup: "",
    incomeBracket: "",
    userBelongsTo: "",
  },

  {
    id:5,
    startupName: "Tellephant",
    website: "https://www.tellephant.com/",
    startupLogo: "https://drive.google.com/uc?export=view&id=1C_NYTeLWb9Il0IUkyo6KNrb04PIYdvKg",
    pSummary: "Tellephant helps your business to leverage the WhatsApp Business API to grow your business at the speed of messaging. Automate your Sales, Marketing, and Customer Support on WhatsApp with Tellephant’s Conversational Commerce Suite.",

    legal_name: "Tellephant",
    industry: "Fintech",
    basedOutOf: "Karnataka, India",
    business_model: "",
    founding_date: "2021",
    employee_headcount: "2021	41 to 60",
    team_member: [
      {
        name: "Suhas Entur",
        designation: "Co-Founder & CPO",
        profile_link: "https://www.linkedin.com/in/suhas-entur/",
      },
     
    ],
    revenue_stream:
      " ",
    customerGroup: "",
    clientBusinessStructure: "",
    geogriphicalSegment: "",
    ageGroup: "",
    incomeBracket: "",
    userBelongsTo: "",
  },

  {
    id:6,
    startupName: "Vidya Sarthi Institute of Digital Marketing",
    website: "https://vidyasarthi.com/",
    startupLogo: "https://drive.google.com/uc?export=view&id=17ZR3yEXS1Xzv8fzr1tskrnM-MYKPfa_X",
    pSummary: "Welcome to Vidya Sarthi Institute of Digital Marketing, where passion meets proficiency in the ever-evolving world of digital marketing. As a leading institute in the field in South Delhi and Faridabad, they empower individuals with the knowledge, skills, and practical expertise necessary to thrive in the digital landscape. At Vidya Sarthi Institute of Digital Marketing, they believe that digital marketing is more than just a skill; it’s a transformative force that has the potential to revolutionize businesses and drive success in the digital age. That’s why their comprehensive programs are designed to equip their students with a deep understanding of the core principles, strategies, and tools required to excel in the digital marketing industry.",

    legal_name: "Vidya Sarthi",
    industry: "Edtech",
    basedOutOf: "Haryana, India",
    business_model: "B2C",
    founding_date: "2017",
    employee_headcount: "<10",
    team_member: [
      {
        name: "Anurag Bhatia",
        designation: "Co-Founder",
        profile_link: "https://www.linkedin.com/in/anurag-bhatiadotin/",
      },
     
    ],
    revenue_stream:
      " Fee-for-service ",
    customerGroup: "Design,  Direct-To-Consumer Brands,  E-Commerce,  Enterprise Tech  ",
    clientBusinessStructure: "Startup",
    geogriphicalSegment: "India,  India Tier 1,  India Tier 2,  Global",
    ageGroup: "18 to 25,  26 to 34,  35 to 45  ",
    incomeBracket: "Lower Income,  Lower-middle Income,  Upper-middle Income  ",
    userBelongsTo: "India,  India Tier 1,  India Tier 2,  India Tier 3  ",
  },

  {
    id:7,
    startupName: "myGuider",
    website: "https://myguider.online/",
    startupLogo: "https://drive.google.com/uc?export=view&id=17BABxgrKg7fyELpcn9QCAqLNXV0YTpxW",
    pSummary: "Empower your professional growth through an all-in-one hub for education, mentorship, and upskilling. - Discover 🌎, explore 🔍, and unlock🔓 new opportunities for career advancement through their innovative portal. - Access expert guidance, resources, and personalized support to shape your educational path and career trajectory. - No longer struggle with navigating the complexities of career development. Their platform is designed to provide seamless and tailored solutions for your professional growth. - Achieve your goals and aspirations with confidence, as their dedicated team of professionals is committed to your success.",

    legal_name: "myGuider Pvt Ltd",
    industry: "Edtech",
    basedOutOf: "Karnataka, India",
    business_model: "B2B",
    founding_date: "2022",
    employee_headcount: "<10",
    team_member: [
      {
        name: "Udhay D",
        designation: "Co-Founder & CEO",
        profile_link: "https://www.linkedin.com/in/udhaygame/",
      },
     
    ],
    revenue_stream:
      " Advertising, Affiliate marketing, Subscription ",
    customerGroup: "EdTech/Education",
    clientBusinessStructure: "Small Enterprise,  Medium Enterprise,  Large Enterprise  ",
    geogriphicalSegment: "India,  Global  ",
    ageGroup: "",
    incomeBracket: "",
    userBelongsTo: "",
  },

];